export default __webpack_public_path__ + "static/media/file.66f78361.svg";